import { all, call, put, takeLatest } from 'redux-saga/effects';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import {
	getLoanInfoBasedOnMemberFailure,
	getLoanInfoBasedOnMemberResponseChanged,
	getLoanInfoBasedOnMemberSuccess,
	getportflioAtRiskFailure,
	getportflioAtRiskResponseChanged,
	getportflioAtRiskSuccess,
} from './portfolio-at-risk-report.action';
import PortFlioAtRiskTypes from './portfolio-at-risk-report.type';
import {
	LoanInfoBasedOnMemberGet,
	PortflioAtRiskDetailsGet,
} from './portfolio-at-risk-report.service';

/** ***************GET PORTFOLIO AT RISK START ************* */
export function* getPortflioAtRisk({ payload }: any) {
	try {
		const {
			companyID,
			branchID,
			userID,
			userLevel,
			databaseName,
			tillDate,
			fromDays,
			toDays,
			userRole,
			officerID,
			searchValue,
			funderID,
			purposeOfLoanID,
		} = payload;
		const key = 'GetPortfolioAtRiskReportKey';
		const jsonData = {
			CompanyID: companyID,
			AreaID: branchID,
			UserID: userID,
			UserLevel: userLevel,
			DatabaseName: databaseName,
			TillDate: tillDate,
			FromDays: fromDays,
			ToDays: toDays,
			UserRole: userRole,
			FieldOfficer: officerID,
			SearchValue: searchValue,
			FunderID: funderID,
			PurposeOfLoanID: purposeOfLoanID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(PortflioAtRiskDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getportflioAtRiskFailure(responseData.data));
		} else {
			yield put(getportflioAtRiskSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getportflioAtRiskFailure(error));
	}
}

export function* resetGetPortfolioReportListResponse() {
	yield put(getportflioAtRiskResponseChanged());
}

export function* onGetPortflioAtRiskListDetails() {
	yield takeLatest(PortFlioAtRiskTypes.PORTFLIO_AT_RISK_START, getPortflioAtRisk);
}

export function* onGetPortflioAtRiskListResponseReset() {
	yield takeLatest(
		PortFlioAtRiskTypes.PORTFLIO_AT_RISK_RESPONSE_RESET,
		resetGetPortfolioReportListResponse,
	);
}
/** ***************GET PORTFOLIO AT RISK END ************* */

/** *********************LOAN_INFO_BASEDON_MEMBER START ******** */
export function* LoanInfoBasedOnMemberDetails({ payload }: any) {
	try {
		const {
			companyID,
			branchID,
			userID,
			userLevel,
			databaseName,
			TillDate,
			fromDays,
			toDays,
			userRole,
			officerID,
			SearchValue,
			funderID,
			PurposeOfLoanID,
		} = payload;
		const key = 'LoanInfoBasedOnMemberClosedKey';
		const jsonData = {
			CompanyID: companyID,
			AreaID: branchID,
			UserID: userID,
			UserLevel: userLevel,
			DatabaseName: databaseName,
			TillDate: TillDate,
			FromDays: fromDays,
			ToDays: toDays,
			UserRole: userRole,
			FieldOfficer: officerID,
			SearchValue: SearchValue,
			FunderID: funderID,
			PurposeOfLoanID: PurposeOfLoanID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(LoanInfoBasedOnMemberGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getLoanInfoBasedOnMemberFailure(responseData.data));
		} else {
			yield put(getLoanInfoBasedOnMemberSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getLoanInfoBasedOnMemberFailure(error));
	}
}

export function* resetGetLoanInfoBasedOnMemberResponse() {
	yield put(getLoanInfoBasedOnMemberResponseChanged());
}

export function* onGetLoanInfoBasedOnMemberDetails() {
	yield takeLatest(
		PortFlioAtRiskTypes.GET_LOAN_INFO_BASEDON_MEMBER_START,
		LoanInfoBasedOnMemberDetails,
	);
}

export function* onGetLoanInfoBasedOnMemberResponseReset() {
	yield takeLatest(
		PortFlioAtRiskTypes.GET_LOAN_INFO_BASEDON_MEMBER_RESPONSE_RESET,
		resetGetLoanInfoBasedOnMemberResponse,
	);
}
/** *********************LOAN_INFO_BASEDON_MEMBER END ******** */

export function* portfolioAtRiskReportSaga() {
	yield all([
		call(onGetPortflioAtRiskListDetails),
		call(onGetPortflioAtRiskListResponseReset),
		call(onGetLoanInfoBasedOnMemberDetails),
		call(onGetLoanInfoBasedOnMemberResponseReset),
	]);
}
